import axios from 'axios'
import store from '@/store'

import { API_BASE, apiErrorHandler, ApiFilter, isDefinedAndNotNull, isNotEmpty } from '../api'
import Auth from '../auth'

const PAYOUTS_ENDPOINT = `${API_BASE}payouts/`
const BATCH_PAYOUTS_ENDPOINT = `${API_BASE}batch-payouts/`
const BATCH_CANCEL_ENDPOINT = `${PAYOUTS_ENDPOINT}batch-cancel/`

export default class PayoutAPI {
  constructor(cls) {
    this.cls = cls
  }

  static create(cls) {
    return new PayoutAPI(cls)
  }

  list({ pagination, filters }) {
    const filtersMap = {
      // Pagination
      page: ApiFilter.create({ key: 'page' }),
      pageSize: ApiFilter.create({ key: 'page_size' }),
      ordering: ApiFilter.create({ key: 'ordering' }),
      employee: ApiFilter.create({ key: 'employee' }),
      statuses: ApiFilter.create({
        key: 'status',
        validators: [isDefinedAndNotNull, isNotEmpty],
        extractor: l => l.join(','),
      }),
      organizations: ApiFilter.create({
        key: 'organization',
        validators: [isDefinedAndNotNull, isNotEmpty],
        extractor: l => l.join(','),
      }),
    }

    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: ApiFilter.buildParams(filtersMap, { ...pagination, ...filters }),
      cache: {
        maxAge: 15 * 1000,
      },
    }

    const promise = store.state.axiosApi.get(`${PAYOUTS_ENDPOINT}`, options)
    return promise
      .then(response => response.data)
      .then(data => {
        return {
          ...data,
          results: data.results.map(this.cls.fromAPI),
        }
      })
      .catch(
        apiErrorHandler({
          apiName: 'PayoutAPI.list',
          rethrowErrors: true,
        }),
      )
  }

  retrieve(payoutId) {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }

    const promise = axios
      .get(`${PAYOUTS_ENDPOINT}${payoutId}/`, options)
      .then(res => this.cls.fromAPI(res.data))
      .catch(apiErrorHandler({ apiName: 'PayoutAPI.retrieve' }))
    return promise
  }

  /**
   * Create a Batch Payout
   *
   * The API will create a batch payout in PayPal for all selectedPayouts.
   */
  createBatchPayout(selectedPayouts, payoutType) {
    const data = {
      recipient_type: 'EMAIL',
      email_subject: 'You have received grant funds from the Grant Circle',
      email_message: `
        Your approved grant funds have been sent to your PayPal account.

        Best,
        Grant Circle team
      `,
      selected_payout_ids: selectedPayouts,
      payout_type: payoutType,
    }
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }

    const promise = axios
      .post(BATCH_PAYOUTS_ENDPOINT, data, options)
      .catch(apiErrorHandler({ apiName: 'PayoutAPI.batchPayout' }))
    return promise
  }

  batchCancel(selectedPayouts) {
    const data = {
      selected_payout_ids: selectedPayouts,
    }
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }

    const promise = axios
      .post(BATCH_CANCEL_ENDPOINT, data, options)
      .catch(apiErrorHandler({ apiName: 'PayoutAPI.batchCancel' }))
    return promise
  }
}
